import { render, staticRenderFns } from "./JobSubjectLeader.vue?vue&type=template&id=2022bbfa&scoped=true"
import script from "./JobSubjectLeader.vue?vue&type=script&lang=js"
export * from "./JobSubjectLeader.vue?vue&type=script&lang=js"
import style0 from "./JobSubjectLeader.vue?vue&type=style&index=0&id=2022bbfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2022bbfa",
  null
  
)

export default component.exports